import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const InstitutionsImage = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="28" height="24" fill="none" viewBox="0 0 56 42">
      <path
        d="M3.38608 27.3282V51.2278H51.0063V27.2371C51.0063 27.2371 41.479 20.6039 41.04 20.5418C40.6009 20.4796 27.8035 8.6582 27.8035 8.6582L13.6971 20.1401L3.38608 27.3282Z"
        fill="#F8C778"
      />
      <path
        d="M3.38608 27.469H14.6285L14.6162 51.227H16.4831L16.4954 22.3034L27.5245 12.5647L38.652 22.7726L38.6233 51.227H40.3712L40.3999 27.3332L51.0063 27.4073V25.9873L41.3313 20.7845L28.3902 9.37891L14.1033 20.5499L3.39428 26.1107L3.38608 27.469Z"
        fill="#F5B03F"
      />
      <path
        d="M5.68524 17.6397C5.61084 17.7555 2.72967 25.4271 2.67593 25.5867C2.62219 25.7464 2.7586 25.934 3.0893 25.9619C3.41999 25.9899 14.8248 25.9619 14.8248 25.9619L14.7917 21.26C14.7917 21.26 27.0357 10.6187 27.1721 10.6187C27.3085 10.6187 39.6475 21.5354 39.6764 21.699C39.7054 21.8587 39.7302 25.7783 39.7302 25.7783C39.7302 25.7783 50.5811 25.8581 50.8043 25.8861C51.0275 25.914 51.0812 25.6187 50.887 25.0598C50.6927 24.501 48.4274 17.7555 48.2621 17.6477C48.0967 17.5399 39.1515 17.5399 39.1515 17.5399C39.1515 17.5399 27.9451 7.57723 27.7508 7.41757C27.5565 7.25791 26.9778 7.01443 26.4652 7.50937C26.0147 7.94444 14.8372 17.6198 14.8372 17.6198C14.8372 17.6198 5.76792 17.504 5.68524 17.6397Z"
        fill="#A62714"
      />
      <path
        d="M18.5421 33.2097L18.538 51.2274H35.8544V33.2097C35.8544 33.2097 18.5421 33.1641 18.5421 33.2097Z"
        fill="#CF6150"
      />
      <path
        d="M2.0753 51.0625C2.22995 51.2974 4.03564 51.1883 8.84661 51.2135C13.6576 51.2387 15.0578 51.2303 15.3086 51.1799C15.5552 51.1296 15.7559 50.0431 15.5928 49.0993C15.4131 48.0631 14.7945 47.0857 13.7913 46.7711C12.4496 46.3516 11.622 46.7376 10.9783 46.511C10.3346 46.2887 8.44953 45.3407 6.53935 45.4665C4.90086 45.5714 3.73469 46.0538 2.71899 47.5556C1.62806 49.1706 1.97498 50.9115 2.0753 51.0625Z"
        fill="#7DB240"
      />
      <path
        d="M52.3565 50.9586C52.6052 50.8048 52.5842 46.5438 49.2539 46.2175C46.7541 45.9737 46.1007 46.9302 45.6791 46.9302C45.2534 46.9302 43.6346 46.2288 41.4004 46.9977C38.6223 47.9542 38.6729 50.7373 38.7741 51.0036C38.8753 51.2699 41.7503 51.2024 45.7002 51.2249C49.6502 51.2474 52.0319 51.1611 52.3565 50.9586Z"
        fill="#7DB240"
      />
      <path
        d="M5.64587 28.8613H12.7658V35.355H5.55063C5.55063 35.355 5.59634 28.9131 5.64587 28.8613Z"
        fill="#3E737C"
      />
      <path
        d="M4.89676 38.2404H12.7658V44.0124H4.8291C4.8291 44.0163 4.86293 38.2086 4.89676 38.2404Z"
        fill="#3E737C"
      />
      <path d="M6.3411 29.582H11.3228V33.9111H6.27834C6.27834 33.9111 6.24304 29.6168 6.3411 29.582Z" fill="#A7D0D7" />
      <path d="M6.27216 38.9629H12.0443V42.5705H6.27216V38.9629Z" fill="#A7D0D7" />
      <path
        d="M41.6575 28.8625H48.8418V35.355H41.6266C41.6266 35.355 41.6575 28.7585 41.6575 28.8625Z"
        fill="#3E737C"
      />
      <path d="M42.3481 30.3047H48.1203V33.9123H42.3481V30.3047Z" fill="#A7D0D7" />
      <path
        d="M41.6473 38.2402H48.8418V44.0124H41.6473C41.6473 44.0124 41.6007 38.2932 41.6473 38.2402Z"
        fill="#3E737C"
      />
      <path
        d="M42.3485 38.9982V42.5705H48.1203V38.9655C48.1203 38.9655 42.294 38.9492 42.3485 38.9982Z"
        fill="#A7D0D7"
      />
      <path d="M21.4281 51.2269L21.424 35.3535H33.6899V51.2269H21.4281Z" fill="#3E737C" />
      <path d="M32.2468 38.2407V36.0762H22.8671V38.2407H32.2468Z" fill="#A7D0D7" />
      <path d="M22.6578 39.5605H32.1596V45.0142H22.6578V39.5605Z" fill="#A7D0D7" />
      <path d="M22.6578 46.1367H32.1596V48.9889H22.6578V46.1367Z" fill="#A7D0D7" />
      <path
        d="M27.1962 39.0737V49.7857H27.9177V38.9629C27.9177 38.9629 27.2454 39.0737 27.1962 39.0737Z"
        fill="#3E737C"
      />
      <path
        d="M26.8954 16.596C22.6321 16.6331 19.7748 19.8213 19.9927 23.921C20.2023 27.9052 23.3556 30.4046 27.0023 30.3015C30.8339 30.1943 33.5802 27.1092 33.6871 23.4508C33.794 19.7924 30.8339 16.563 26.8954 16.596Z"
        fill="#3E737C"
      />
      <path
        d="M26.8716 18.0371C23.522 18.0371 21.2876 20.5869 21.4305 23.657C21.5655 26.6199 23.5578 28.8599 26.9788 28.8599C30.1181 28.8599 32.1818 26.2783 32.2453 23.6213C32.3128 20.722 30.1498 18.0371 26.8716 18.0371Z"
        fill="white"
      />
      <path
        d="M25.9129 23.8546C25.9129 23.8546 23.7789 25.6049 23.6613 25.8089C23.5437 26.0128 23.548 26.3484 23.8311 26.5736C24.1186 26.7987 24.4016 26.667 24.5758 26.5353C24.7457 26.4036 26.9973 24.6023 26.9973 24.6023C26.9973 24.6023 27.7246 24.5896 27.8945 23.7484C28.0295 23.0772 27.533 22.7628 27.533 22.7628C27.533 22.7628 27.4546 18.7438 27.4198 18.4464C27.3893 18.2255 27.1541 18.0174 26.945 18.0386C26.736 18.0556 26.5269 18.1703 26.5052 18.5017C26.4834 18.833 26.4616 22.6821 26.4616 22.6821C26.4616 22.6821 26.1568 22.7925 25.9869 23.1111C25.8171 23.4255 25.9129 23.8546 25.9129 23.8546Z"
        fill="#2F2F2F"
      />
    </SvgIcon>
  );
};

export default InstitutionsImage;
